module.exports = __webpack_public_path__ + "static/media/qiwi.70af41ea.png";